import { TracerLogger } from 'src/services/logger/Logger';
import * as RuntimeConfigurationService from './RuntimeConfigurationService/RuntimeConfigurationService.client';

export abstract class ClientConfigProvider {
    protected logger: TracerLogger;
    protected runtimeConfig: RuntimeConfigurationService.ConfigProvider;

    public constructor({ runtimeConfig }: { runtimeConfig: RuntimeConfigurationService.ConfigProvider }) {
        this.logger = console;
        this.runtimeConfig = runtimeConfig;
    }
}
